import { Box, Text } from '@chakra-ui/react'

export const MultiLayer = () => {
  return (
    <Box p={4} bg="white" borderRadius="lg" shadow="sm">
      <Text fontSize="lg" fontWeight="bold" mb={4}>Multi-Layer View</Text>
      {/* Layer controls will go here */}
    </Box>
  )
}
